import DialogSelect, {
  type DialogSelectProps,
} from "@/components/DialogSelect";
import { type HBModalProps } from "@/components/HBModal";
import ModalWrap from "@/components/HBModal/ModalWrap";
import { getTags } from "@/services";
import groupRecordsByPinyin from "@/utils/groupRecordsByPinyin";
import useReq from "@/utils/useReq";
import { useMemoizedFn } from "ahooks";
import { useRouter } from "next/router";
import { useMemo, useState } from "react";

export function useTagSelect(urlname, needPingyin = true) {
  const { data: tags, loading } = useReq(async () => {
    const { tags, err } = await getTags({
      urlname,
      limit: 1000,
    });
    if (err) return [];

    if (needPingyin) {
      const groupResult = await groupRecordsByPinyin(
        tags,
        (item) => item.tag_name
      );

      // 扁平化处理
      const list = [];

      groupResult.forEach((item) => {
        const pinyin = item[0];
        const items = item[1];

        list.push(
          ...items.map((item, index) => {
            return {
              key: item.tag_name,
              label: item.tag_name,
              count: item.count,
              pinyin: index === 0 ? pinyin : undefined,
            };
          })
        );
      });

      return list;
    }
    return tags.map((item) => {
      return {
        key: item.tag_name,
        label: item.tag_name,
        count: item.count,
      };
    });
  });

  const [searchKeyword, setSearchKeyword] = useState("");
  const onSearch = useMemoizedFn((keyword: string) => {
    setSearchKeyword(keyword);
  });

  const filteredTags = useMemo(() => {
    if (!searchKeyword) return tags;
    return tags.filter((item) => item.label.includes(searchKeyword));
  }, [tags, searchKeyword]);

  return {
    tags: filteredTags,
    onSearch,
    loading,
  };
}

function TagSelect({
  urlname,
  needPingyin = true,
  ...props
}: {
  urlname: string;
  needPingyin?: boolean;
} & DialogSelectProps &
  HBModalProps) {
  const { tags, onSearch, loading } = useTagSelect(urlname, needPingyin);

  const router = useRouter();

  return (
    <DialogSelect
      {...props}
      title="标签"
      items={tags}
      manageButtonText="管理标签"
      onManage={() => {
        router.push(`/space/tags`);
        props.onCancel?.();
      }}
      onSearch={onSearch}
      onOk={(tags) => {
        if (tags.length) {
          router.push(`/space/tags/${encodeURIComponent(tags[0])}`);
        }
        props.onCancel?.();
      }}
      loading={loading}
    />
  );
}

const TagSelectModal = ModalWrap(TagSelect);

export default TagSelectModal;
